import React, { useEffect, useState, useRef } from "react";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import '../menu.css'
import { Ripple } from "primereact/ripple";
import { LoginResponse } from "../../../models/index";
import { wglcsApiService } from "../../../services/WglcsApiService";
import _ from "lodash";
import moment from "moment";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column'
import { Skeleton } from "primereact/skeleton";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import * as XLSX from 'xlsx';
import { ProgressSpinner } from "primereact/progressspinner";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import html2canvas from 'html2canvas';
import EventEmitter, { Events } from "../../../services/eventemitter";
import { MultiSelect } from 'primereact/multiselect';
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { t } from "i18next";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const MonthlyTrafficReport = () => {
    const tableRef = useRef(null);
    var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse
    const fDate = new Date();
    fDate.setDate(1); // Set to the first day of the month
    const [fromDate, setFromDate] = useState<any>(fDate);
    const [toDate, setToDate] = useState<any>(new Date());
    const [selectedCompanyName, setSelectedCompanyName] = useState<any>(null);
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [selectedTimeZone, setSelectedTimeZone] = useState<any>(null);
    const [loadingCompanies, setLoadingCompanies] = useState(true)
    const [CompanyArray, setCompanyArray] = useState([])
    const [WebsiteArray, setWebsiteArray] = useState<any>([])
    const [TimeArray, setTimeArray] = useState<any>([])
    const [searchText, setSearchText] = useState("")
    const [monthlytrafficreport, setMonthlyTrafficReport] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [timeloading, setTimeLoading] = useState(true)
    const [defaultTime, setDefaultTime] = useState<any>(null);
    const timeZoneRef = useRef<any>(null);
    const CompanyRef = useRef<any>(null);
    const [uniqueMonths, setUniqueMonths] = useState<any>([])
    const [exportloading, setExportLoading] = useState(false)
    const [hidebutton, setHideButton] = useState(true)
    const skeletonLength = [
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
    ]
    const [filters, setFilters] = useState({
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    useEffect(() => {
        ApiCalls()
    }, [])

    useEffect(() => {
        timeZone()
    }, [selectedWebsite])

    const ApiCalls = async () => {
        loadCompanies()
        timeZone()
    };
    const loadCompanies = async () => {
        let apiResponse = await wglcsApiService.getallCompaniesbyEmployeeCompanyid(userData?.userLoginData?.empCompId.toString());
        var arr = _.orderBy(apiResponse?.data?.data, ["companyName"], ["asc"]);
        setCompanyArray(arr as any)
        setLoadingCompanies(false)
    };
    const timeZone = async () => {
        let apiResponse = await wglcsApiService.GetAllReportingTimeZones();
        if (apiResponse) {
            setTimeLoading(false)
            if (selectedWebsite != null) {
                var data = apiResponse.data.filter(m => m.standardName == selectedWebsite.timeZone)
                if (data.length > 0) {
                    setTimeArray(apiResponse.data)
                    setSelectedTimeZone(data[0])
                    setDefaultTime(data[0])
                } else {
                    var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
                    setTimeArray(apiResponse.data)
                    setSelectedTimeZone(data[0])
                    setDefaultTime(data[0])
                }
            }
            else {
                var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
                setTimeArray(apiResponse.data)
                setSelectedTimeZone(data[0])
                setDefaultTime(data[0])
            }
        }
    }
    const onTimeChange = (e) => {
        setSelectedTimeZone(e.value);
    }
    const fromData = (e) => {
        setFromDate(e.value)
    }
    const toData = (e) => {
        setToDate(e.value)
    }
    const searchClear = () => {
        setSearchText("")
        setFilters({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        })
    }
    const handleSearch = (e) => {
        const value = e.target.value;
        let _filters1 = { ...filters };
        _filters1['global'].value = value;
        setFilters(_filters1);
        setSearchText(value)
    }

    const MTR = async () => {
        let requestBody = {
            fromDate: moment(fromDate).format("YYYY-MM-DD"),
            toDate: moment(toDate).format("YYYY-MM-DD"),
            companyId: selectedCompanyName?.companyId,
            websiteId: selectedWebsite?.map(m => m.websiteId).join(','),
            timeZone: selectedTimeZone?.standardName,
            timeType: "",
            agentId: 0,
            chatCountBy: "",
            timeFrom: "",
            timeTo: "",
            region: "",
        }
        var result = await wglcsApiService.monthlytrafficreport(requestBody)
        if (result.data.data) {
            let newArray: any = []
            result.data.data.forEach(element => {
                var filtered = result.data.data?.filter(x => x.websiteId == element.websiteId)
                if (!newArray.some(c => c.websiteId == element.websiteId)) {
                    newArray.push({ websiteId: element.websiteId, websiteTitle: element.websiteTitle, Values: filtered })
                }
            });
            const uniqueMonth = result.data.data.map(item => item.mmonth + " " + item.yyear);
            setMonthlyTrafficReport(newArray)
            // Use a Set to remove duplicates
            const uniqueMonthsAndYearsSet = new Set(uniqueMonth);
            // Convert the Set back to an array
            const uniqueMonthsAndYearsArray = Array.from(uniqueMonthsAndYearsSet);
            setUniqueMonths(uniqueMonthsAndYearsArray)
        } else {
            setMonthlyTrafficReport([])
        }
        setLoading(false)
    }
    const submit = () => {
        if (!selectedCompanyName) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t('toast.Company-validation'))
            return;
        }
        else {
            setLoading(true)
            MTR()
            setHideButton(false)
        }
    }
    const onCompanyChange = (e) => {
        setSelectedCompanyName(e.value);
        loadWebsites(e.value.companyId);
    }
    const loadWebsites = async (id) => {
        let response = await wglcsApiService.getwebsitebycompanyId(id);
        var data = response.data.data.filter(m => m.status === true)
        setWebsiteArray(data)
        var multiselectData = data[0]
        setSelectedWebsite([multiselectData])
    };
    const CompanyOptionTemplate = (option) => {
        if (loadingCompanies) {
            return (
                <div style={{ margin: "2px" }} >
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.companyName}</div>
                </div>
            );
        }
    };
    const renderSearchField = () => {
        return (
            <div className="search-view">
                <input
                    className="searchfeild"
                    value={searchText}
                    onChange={handleSearch}
                    placeholder={t("Search")}
                />
                <i className="fa-light fa-search search-icon"></i>
                {searchText.length > 0 && <i onClick={searchClear} className="fa fa-times clear-icon"></i>}
            </div>
        )
    }
    const ExportPDF = async () => {
        setExportLoading(true)
        const element = document.getElementById('reportContent');
        if (element) {
            const pdf = new jsPDF();

            // Add the image to the PDF
            const logoWidth = 45;
            const logoHeight = 15;
            const logoY = 5;
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const centerX = (pdfWidth - logoWidth) / 2;

            const imageElement = document.getElementById('logoImage');
            const imgDataUrl = imageElement?.getAttribute('src') || ''; // Get the image source URL
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (ctx) {
                // Draw the image onto the canvas
                const img = new Image();
                img.src = imgDataUrl;
                await new Promise(resolve => {
                    img.onload = () => {
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        resolve(null);
                    };
                });

                // Add the HTML content to the PDF
                const canvasContent = await html2canvas(element);
                const imgContentData = canvasContent.toDataURL('image/png');
                pdf.addImage(imgContentData, 'PNG', 5, 30, 200, 80);

                // Add the logo image to the PDF
                const imgData = canvas.toDataURL('image/svg');
                pdf.addImage(imgData, 'SVG', centerX, logoY, logoWidth, logoHeight);

                pdf.save('Monthly Traffic Report.pdf');
            }
        }
        setExportLoading(false)
    };
    const ExportExcel = () => {
        const data = monthlytrafficreport.map(row => {
            const rowData = {
                'Website Title': row.websiteTitle,
            };

            uniqueMonths.forEach(header => {
                const cellWiseData = row.Values?.find(x => x.websiteId === row.websiteId && `${x.mmonth} ${x.yyear}` === header);
                if (cellWiseData) {
                    rowData[header + ' - Visitor Count'] = cellWiseData.visitorCount;
                    rowData[header + ' - Total Chat Count'] = cellWiseData.chats;
                    rowData[header + ' - Billable Chat Count'] = cellWiseData.billableChats;
                } else {
                    // If data is not available, set 0 in the cell
                    rowData[header + ' - Visitor Count'] = 0;
                    rowData[header + ' - Total Chat Count'] = 0;
                    rowData[header + ' - Billable Chat Count'] = 0;
                }
            });
            return rowData;
        });

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        XLSX.writeFile(wb, 'Monthly_Traffic_Report.xlsx');
    };
    const TimeTemplate = (option) => {
        if (timeloading) {
            return (
                <div style={{ margin: "2px" }}>
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.displayName}</div>
                </div>
            );
        }
    };
    const exportSelectedWebsite = () => {
        if (selectedWebsite) {
            return t('From') + ":" + moment(fromDate).format("MM-DD-YYYY") + " " + t("To") + ":" + moment(toDate).format("MM-DD-YYYY")
        } else {
            return ""
        }
    }
    const WebsiteItemTemplate = (option) => {
        return (
            <div className="country-item">
                <div>{option.domainName}</div>
            </div>
        );
    }
    const renderLoader = () => {
        return (
           
                <ProgressSpinner strokeWidth="3" fill="#EEEEEE" style={{ height: "20px", width: "20px", marginTop: "2px" }} animationDuration=".5s" />
          
        );
    }
    const getMonthColumn = uniqueMonths.map(header => (
        <Column style={{ width: '35%' }} key={header} field={header} header={() => renderHeader(header)} body={(e) => bodyTemplate(e, header)} />
    ))
    const renderHeader = (headerName) => {
        return <>
            <div className="row">
                <div className="col" style={{ textAlign: "center", fontSize: "14px", marginBottom: "5px" }}>
                    {headerName}
                </div>
            </div>
            <div className="row">
                <div title="Visitor Count" className={uniqueMonths.length === 1 ? "col singlecolStyle" : uniqueMonths.length > 1 && uniqueMonths.length <= 3 ? "col doublecolStyle" : "col colStyle"}>
                    {uniqueMonths.length <= 3 ? <span>{t('GraphReports-label.Visitor-Count')}</span> : uniqueMonths.length === 1 ? <span>{t('GraphReports-label.Visitor-Count')}</span> : <span>V.C</span>}
                </div>
                <div title="Total Chat Count" className={uniqueMonths.length === 1 ? "col singlecolStyle" : uniqueMonths.length > 1 && uniqueMonths.length <= 3 ? "col doublecolStyle" : "col colStyle"}>
                    {uniqueMonths.length <= 3 ? <span>{t('ReportComponent.Total Chats')}</span> : <span>T.C</span>}

                </div>
                <div title="Billabel Chat Count" className={uniqueMonths.length === 1 ? "col singlecolStyle" : uniqueMonths.length > 1 && uniqueMonths.length <= 3 ? "col doublecolStyle" : "col colStyle"}>
                    {uniqueMonths.length <= 3 ? <span>{t('GraphReports-label.Billable-Chats')}</span> : <span>B.C</span>}

                </div>
            </div>
        </>

    }
    const bodyTemplate = (row, cell) => {
        const cellWiseData = row.Values?.find(x => x.websiteId == row.websiteId && x.mmonth + " " + x.yyear?.toString() == cell?.toString())
        if (cellWiseData == undefined) {
            return (
                <div className="row">
                    <div className="col colStyle">
                        <span>0</span>
                    </div>
                    <div className="col colStyle">
                        <span>0</span>
                    </div>
                    <div className="col colStyle">
                        <span>0</span>
                    </div>
                </div>
            )
        }
        return <>
            <div className="row">
                <div className="col colStyle">
                    <span>{cellWiseData.visitorCount}</span>
                </div>
                <div className="col colStyle">
                    <span>{cellWiseData.chats}</span>
                </div>
                <div className="col colStyle">
                    <span>{cellWiseData.billableChats}</span>
                </div>
            </div>
        </>
    }
    const generateTableHeaders = () => {
        return (<>
            {uniqueMonths.map(header => (<>
                {/* <th style={{ background: "#84bdf3", border: "1px solid #000" }}></th> */}
                <th style={{ fontSize: "16px", color: "black", textAlign: "center", background: "#84bdf3", border: "1px solid #000" }} colSpan={5}>{header}</th>
            </>))}
            <tr>
                {uniqueMonths.map((header, index) => (
                    <React.Fragment key={index}>
                        <th></th>
                        <th></th>
                        <th style={{ color: "black", textAlign: "center" }}>{uniqueMonths.length <= 3 ? t('GraphReports-label.Visitor-Count') : 'V.C'}</th>
                        <th style={{ color: "black", textAlign: "center" }}>{uniqueMonths.length <= 3 ? t('ReportComponent.Total Chats') : 'T.C'}</th>
                        <th style={{ color: "black", textAlign: "center" }}>{uniqueMonths.length <= 3 ? t('GraphReports-label.Billable-Chats') : 'B.C'}</th>
                    </React.Fragment>
                ))}
            </tr >
        </>)
    };

    const bodyTemplateToHTML = (row, cell) => {
        let cellWiseData = row.Values?.find(x => x.websiteId == row.websiteId && x.mmonth + " " + x.yyear?.toString());
        if (cellWiseData === undefined) {
            return (<React.Fragment>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td></td>
                <td></td>
            </React.Fragment>)

        } else {
            return (<React.Fragment>
                <td>{cellWiseData.visitorCount}</td>
                <td>{cellWiseData.chats}</td>
                <td>{cellWiseData.billableChats}</td>
                <td></td>
                <td></td>
            </React.Fragment>)
        }
    };


    return (
        <div className="wgReoprts-container">
            <div className="row p-2">
                <img id="logoImage" style={{ display: "none" }} src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="" />
                <div className="wgreport-tab viewreport-box">
                    <div className="row view-wgreport ">
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="firstname6">{t('smtp-DataTable.Company-Name')}</label>
                            <div className="spinner-box">
                            <Dropdown className="form-control"
                                filter
                                showFilterClear
                                filterBy="companyName"
                                value={selectedCompanyName}
                                options={CompanyArray}
                                onChange={onCompanyChange}
                                optionLabel="companyName"
                                placeholder={!loadingCompanies ? t('fieldsPlaceholder.selectCompany') : selectedCompanyName} itemTemplate={CompanyOptionTemplate}
                            //  ref={CompanyRef}
                            />
                            {loadingCompanies && renderLoader()}
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="basic">{t('MonitoringPanel 6erComponent.Website-Name')}</label>
                            <MultiSelect
                                className="form-control"
                                maxSelectedLabels={2}
                                filter
                                showClear
                                value={selectedWebsite}
                                options={WebsiteArray}
                                onChange={(e) => setSelectedWebsite(e.value)}
                                itemTemplate={WebsiteItemTemplate}
                                optionLabel="domainName"
                                placeholder={t('ReportComponent.Select Website')} />
                        </div>
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="firstname6">{t('ChatTranscriptComponent.From Date')}</label>
                            <Calendar showIcon value={fromDate} onChange={(e) => fromData(e)}
                                minDate={new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1)}
                                maxDate={new Date()}
                            />
                        </div>

                        <div className="col-md-3 col-lg-3 py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.To Date')}</label>
                            <Calendar id="abc" showIcon value={toDate} onChange={(e) => toData(e)}
                                maxDate={new Date()}
                                minDate={new Date(fromDate.getFullYear(), fromDate.getMonth(), 1)}
                            />
                        </div>

                   
                        <div className="col-md-3 col-lg-3  py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ManagePoc-DataTable.Time-Zone')}</label>
                            <div className="spinner-box">
                            <Dropdown className="form-control"
                                filter
                                showFilterClear
                                filterBy="displayName"
                                value={selectedTimeZone}
                                options={TimeArray}
                                onChange={onTimeChange}
                                optionLabel="displayName"
                                itemTemplate={TimeTemplate}
                                placeholder={!timeloading ? t('ManagePoc-DataTable.Select-TimeZone') : selectedTimeZone}
                            //ref={timeZoneRef}
                            />
                            {timeloading && renderLoader()}
                            </div>
                        </div>
                        <div className="col-md-9 py-1 text-right text-md-left">
                            {hidebutton == false ? <>
                                <span title={t('wg-buttons.Export-Excel')}>
                                    <ReactHTMLTableToExcel
                                        id="test-table-xlsx-button search-btn"
                                        className="btn-width wgreport-btn wgbtn p-ripple"
                                        table="table-to-xlsx"
                                        filename={t('DashboardReports.MonthlyTrafficReport')}
                                        sheet={t('DashboardReports.MonthlyTrafficReport')}
                                        buttonText={t('wg-buttons.Export-Excel')}
                                    />
                                </span>
                                <button title={t('wg-buttons.Export-PDF')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => ExportPDF()}> <Ripple />{exportloading ?
                                    <ProgressSpinner
                                        style={{ width: "25px", bottom: "8px" }}
                                        strokeWidth="3"
                                        fill="#EEEEEE"
                                        animationDuration=".5s"
                                    /> : t('wg-buttons.Export-PDF')}</button>
                            </> : ""}  <button title={t('wg-buttons.View-Report')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => submit()}> <Ripple />{t('wg-buttons.View-Report')}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div id="reportContent">
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="wgreport-span">{t('DashboardReports.MonthlyTrafficReport')}</div>
                        <div className="wgreport-span">{exportSelectedWebsite()}</div>
                    </div>
                </div>
                <div className="row ">
                    <div className="col-12">
                        {renderSearchField()}</div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {loading == true ?
                            <ProgressSpinner
                                style={{ width: "50px", marginLeft: "50%", marginTop: "10%" }}
                                strokeWidth="3"
                                fill="#EEEEEE"
                                animationDuration=".5s"
                            /> :
                            <div className='visitor-data-table'>
                                <DataTable
                                    value={monthlytrafficreport}
                                    // responsiveLayout="scroll"
                                    filterDisplay="menu"
                                    // className="p-datatable-lg p-datatable-responsive-demo"
                                    emptyMessage={t('resourcesPoolTable.Data Not Found')}
                                    filters={filters}
                                    paginator
                                    rows={10}
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                    rowsPerPageOptions={[10, 25, 30]}
                                >
                                    <Column  field="websiteTitle" header={t("Companies.Website-Title")} />
                                    {getMonthColumn}
                                </DataTable>
                            </div>
                        }
                    </div>
                    <div className='htmltable' style={{ display: 'none' }}>
                        {monthlytrafficreport && <table id="table-to-xlsx" ref={tableRef}>
                            <thead>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td style={{ fontSize: "18px", color: "black", textAlign: "center", fontWeight: 600 }} colSpan={5}>{t('DashboardReports.MonthlyTrafficReport')}</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <th style={{ fontSize: "16px", color: "black", textAlign: "center", fontWeight: 400 }} colSpan={5}>{exportSelectedWebsite()}</th>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th style={{ width: "8%", background: "#84bdf3", border: "1px solid #000" }}>
                                        {t("Companies.Website-Title")}
                                    </th>
                                    {generateTableHeaders()}
                                </tr>
                                {monthlytrafficreport.map((item, index) => (
                                    <tr key={index}>
                                        <td>&nbsp;</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.websiteTitle}</td>
                                        {uniqueMonths.map(header => bodyTemplateToHTML(item, header))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>}
                    </div>
                </div>
            </div>
        </div>)
}
export default MonthlyTrafficReport